(function () {
  const STORAGE_KEY = 'hide_oos_toggle';

  function applyHide() {
    const hide = localStorage.getItem(STORAGE_KEY) === '1';
    const checkbox = document.getElementById('toggle-instock');
    if (checkbox) checkbox.checked = hide;

    document.querySelectorAll('[data-product-card][data-available]').forEach((el) => {
      const available = el.dataset.available === 'true';
      el.style.display = hide && !available ? 'none' : '';
    });
  }

  function initToggle() {
    const checkbox = document.getElementById('toggle-instock');
    if (checkbox && !checkbox.dataset.bound) {
      checkbox.addEventListener('change', (e) => {
        localStorage.setItem(STORAGE_KEY, e.target.checked ? '1' : '0');
        applyHide();
      });
      checkbox.dataset.bound = '1';
    }

    applyHide();

    // Re-apply after AJAX/pagination re-renders
    const grid = document.querySelector('[data-product-grid]');
    if (grid && !grid.dataset.observing) {
      new MutationObserver(() => applyHide()).observe(grid, { childList: true, subtree: true });
      grid.dataset.observing = '1';
    }
  }

  document.addEventListener('DOMContentLoaded', initToggle);
  document.addEventListener('shopify:section:load', initToggle);
})();
